const MEETING_MODE = {
  doubleListening: 'DOUBLE_LISTENING',
  record: 'RECORD',
  scenario: 'SCENARIO',
  training: 'TRAINING',
};

export default MEETING_MODE;
